import React, { useRef, useEffect } from 'react';
import c from 'classnames';
import { List } from 'immutable';
import { useSelector } from 'react-redux';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { Node } from '@uncinc/react-drupal-core';

import Pager from '../../../components/Pager';

import './style.scss';

const ViewVacanciesByIds = (props) => {
  const ref = useRef(null);
  const viewIsLoaded = useRef(null);
  const { entities, page, setCurrentPage, totalPages } = props;
  const vacancyIdsByDistance = useSelector((state) => state.getIn(['uiInternal', 'vacancy_ids_by_distance', 'ids'], List()));
  const vacancyIds = vacancyIdsByDistance.toJS();
  useEffect(() => {
    if (ref.current) {
      if (viewIsLoaded.current) {
        ref.current.scrollIntoView();
      } else {
        viewIsLoaded.current = true;
      }
    }
  }, [ref, page]);

  const setNewCurrentPage = (newPage) => {
    window.scroll({ top: 0, left: 0 });
    setCurrentPage(newPage);
  };

  const ViewClasses = c('ViewVacanciesByIds', {
    'ViewVacanciesByIds--no-pager': totalPages <= 1,
  });

  return (
    entities.size > 0 && (
      <div className={ViewClasses} ref={ref}>
        <Container>
          <div className="row">
            {entities.sort((first, second) => {
              const firstPlace = vacancyIds.indexOf(first.getIn(['nid', 0, 'value']));
              const secondPlace = vacancyIds.indexOf(second.getIn(['nid', 0, 'value']));
              if (secondPlace > firstPlace) {
                return -1;
              }
              return 1;
            }).map((entity, index) => {
              const id = entity.getIn(['nid', 0, 'value']);
              const uuid = entity.getIn(['uuid', 0, 'value']);
              return (
                <div key={uuid} className="col-12">
                  <Node
                    id={id}
                    entity={entity}
                    viewMode="teaser"
                  />
                </div>
              );
            })}
          </div>
          <div className="ViewVacanciesByIds__pager">
            <Pager currentPage={page} totalPages={totalPages} setCurrentPage={setNewCurrentPage} />
          </div>
        </Container>
      </div>
    )
  );
};

export default ViewVacanciesByIds;
